import Meta from '@/components/common/Meta'

import DhlLuggageShippingPage from '@/v2/components/pages/landing-pages/dhl-luggage-shipping-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/dhl-luggage-shipping-page'

interface DhlLuggageShippingPageProps {}

const Page: React.FC<DhlLuggageShippingPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.dhl_luggage_shipping.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.dhl_luggage_shipping?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.dhl_luggage_shipping?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <DhlLuggageShippingPage />
    </>
  )
}

export default Page
